export enum UserRole {
  manager = 'manager',
  viewer = 'viewer',
  external = 'external',
  support = 'support',
}